import { ExtensionProperty, IProperty, Nullable, PropertyType } from "@gltf-transform/core3";
import { CYNCLY_MATERIALS_METADATA } from "../constants";

interface IMaterialMetadata extends IProperty {
	mCode: string | null;
}

/**
 * Defines Material metadata attached to a {@link Material}. See {@link CYNCLYMaterialsMetadata}.
 */
export class MaterialMetadata extends ExtensionProperty<IMaterialMetadata> {
	public static EXTENSION_NAME = CYNCLY_MATERIALS_METADATA;
	public extensionName = CYNCLY_MATERIALS_METADATA;
	public propertyType = "MaterialMetadata";
	public parentTypes = [PropertyType.MATERIAL];

	protected init(): void {
		this.extensionName = CYNCLY_MATERIALS_METADATA;
		this.propertyType = "MaterialMetadata";
		this.parentTypes = [PropertyType.MATERIAL];
	}

	protected getDefaults(): Nullable<IMaterialMetadata> {
		return Object.assign(super.getDefaults() as IProperty, {
			mCode: null,
		});
	}

	public getMCode(): string | null {
		return (this as any).get("mCode");
	}

	public setMCode(mCode: string | null): this {
		return (this as any).set("mCode", mCode);
	}
}
